import {Formik, FormikHelpers} from 'formik';
import React, {useContext, useEffect} from 'react';
import {connect} from 'react-redux';
import {AccountSettingsFormContainer} from 'shared/account-settings/FormContainer';
import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';
import {changesSaved} from 'shared/actions/notifications';
import Label from 'shared/components/label';
import styles from 'src/components/AccountSettings/styles.module.scss';
import FormikTextField from 'src/components/FormikTextField';
import PasswordInstructionsTooltip from 'src/components/PasswordInstructionsTooltip';
import {PlatformContext} from 'src/components/PlatformContext';
import IonLink from 'src/components/mobile-link';
import ChangePasswordService, {ChangePassword} from 'src/services/ChangePasswordService';
import Yup from 'src/utils/yup';
import MediaQuery from '../../media-query';

interface ChangePasswordFormProps {
  setNavigationAnnouncement: (announcement: string) => void;
  onChangePassword: () => void;
}

const initialValues: ChangePassword = {
  password: '',
  currentPassword: '',
};

const changePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string().required('Current password is required.'),
  password: Yup.string().required('New password is required.'),
});

const ChangePasswordForm = ({
  setNavigationAnnouncement: setAnnouncement,
  ...props
}: ChangePasswordFormProps) => {
  useEffect(() => {
    setAnnouncement('Change Your Password');
  }, [setAnnouncement]);

  const platformContext = useContext(PlatformContext);

  const handleSubmit = async (
    values: ChangePassword,
    formikHelpers: FormikHelpers<ChangePassword>
  ): Promise<void> =>
    ChangePasswordService.savePassword('me', values)
      .then(props.onChangePassword)
      .catch((resetPasswordError) => {
        formikHelpers.setErrors(resetPasswordError.getFieldErrors());
      });

  return (
    <>
      {!platformContext.isIonic && (
        <MediaQuery.MS_AND_DOWN>
          <div className={styles.title}>
            <IonLink to="/account-settings">Account Settings Menu</IonLink>
          </div>
        </MediaQuery.MS_AND_DOWN>
      )}
      <Formik<ChangePassword>
        initialValues={initialValues}
        validationSchema={changePasswordSchema}
        onSubmit={handleSubmit}
        validateOnBlur
      >
        <AccountSettingsFormContainer title="Change Password">
          <Label required>
            Current Password
            <FormikTextField name="currentPassword" placeholder="Password" type="password" />
          </Label>
          <Label required>
            New Password
            <PasswordInstructionsTooltip>
              <FormikTextField name="password" placeholder="New Password" type="password" />
            </PasswordInstructionsTooltip>
          </Label>
        </AccountSettingsFormContainer>
      </Formik>
    </>
  );
};

export default connect(null, {
  setNavigationAnnouncement,
  onChangePassword: () => (dispatch: $TSFixMe) => {
    dispatch(changesSaved());
  },
})(ChangePasswordForm);
